import ModelBase from '../Model'

export const ModelEntity = <E>(entity: E, tableName: string) => {
    return <T extends typeof ModelBase>(constructor: T) => {
        constructor.entity = entity
        constructor.table = tableName
    }
}